import { createFileRoute } from '@tanstack/react-router';

type SearchParams = {
  status?: 'refunded' | 'allInvoices' | 'paid' | 'failed' | 'unpaid' | 'collections';
};

/**
 * Route definition for wrapper library
 */
export const Route = createFileRoute('/payments/invoices')({
  staticData: {
    team: 'payments',
  },
  validateSearch: (search: Partial<SearchParams>): SearchParams => {
    // TODO: validate any of these search params
    return search;
  },
});
